var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.isString)?_c('pre',{staticClass:"json-item",domProps:{"innerHTML":_vm._s(_vm.jsonText)}}):_c('div',{staticClass:"json-item string-box",domProps:{"innerHTML":_vm._s(_vm.jsonText)}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-77986a1e","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/hll-json-box.vue
// module id = 855
// module chunks = 0